import React, { useEffect, useRef } from 'react'

import useStyles from './new-message-indicator.style'

import { useDispatch, useSelector } from 'react-redux'
import { selectChat } from '@selectors'
import { SCROLL_TO_UNREAD, SET_SHOW_SCROLL_INDICATOR } from '@redux/actions/types'

import { INDICATOR_NEW_MESSAGES } from '../../assets/i18n/strings'
import i18n from 'i18n-js'

import { InView } from 'react-intersection-observer'

import Icon from '@components/icon/icon.component'

const NewMessageIndicator = props => {
  const classes = useStyles(props)

  const ref = useRef(null)

  const dispatch = useDispatch()

  const { shouldScrollToUnread } = useSelector(selectChat)
  useEffect(() => {
    if (shouldScrollToUnread) ref.current.scrollIntoView({ behavior: 'smooth' })
  }, [shouldScrollToUnread])

  const onChange = inView => {
    dispatch({
      type: SET_SHOW_SCROLL_INDICATOR,
      payload: !inView
    })

    if (inView) dispatch({ type: SCROLL_TO_UNREAD, payload: false })
  }

  return (
    <InView onChange={onChange}>
      <div
        ref={ref}
        className={classes.container}
      >
        <div className={classes.contentContainer}>
          <span>{i18n.t(INDICATOR_NEW_MESSAGES)}</span>
          <Icon type='arrow-down' />
        </div>
      </div>
    </InView>
  )
}

export default NewMessageIndicator

